//locall
// export const urlapi = 'https://localhost:7127/' 

//Dev
// export const urlapi = 'https://dev-lonapi.ants.co.th/';  //api
// export const pathimages = "https://dev-lon.ants.co.th/img/templateImages/";
// export const logo = "https://dev-lon.ants.co.th/";

//Product
export const urlapi = 'https://api-lon.ants.co.th/' //api
export const pathimages = "https://lon.ants.co.th/img/templateImages/";
export const logo = "https://lon.ants.co.th/";

export var token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1");

export function parseJwt(token) {
    if (token != "") {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    } else {
        window.location.href = window.location.protocol + "//" + window.location.host;
    }
};

export function getExpiredDate(token) {
    var payload = parseJwt(token);
    return new Date(payload.exp * 1000);
}

export function CheckTokenExp() {
    var tokenJwt = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    if (tokenJwt == "") {
        return true;
    } else {
        return false;
    }
}

export const authInfo = "smsreport:P@ssw0rd"
export function set_cookie(value) {
    document.cookie = value;
    token = document.cookie.replace(/(?:(?:^|.*;\s*)__AntiXsrfUerkey\s*\=\s*([^;]*).*$)|^.*$/, "$1");
};

export function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}


// WEBPACK FOOTER //
// ./src/config.js